import qs from 'qs'
import { Http } from './http.init'
import { ResponseWrapper, ErrorWrapper } from './util'

export class BaseService {
  static get baseUrl () {
    return process.env.VUE_APP_URL_GATEWAY
  }

  static request (auth = true) {
    return new Http({ auth, baseUrl: this.baseUrl })
  }

  static get entity () {
    throw new Error('entity getter not defined')
  }

  static responseWrapper (...rest) {
    return new ResponseWrapper(...rest)
  }

  static errorWrapper (...rest) {
    return new ErrorWrapper(...rest)
  }

  static querystring (obj) {
    return qs.stringify(obj, {
      encode: false
    })
  }
}
